import React, { useEffect } from 'react'

import api from '../services/api'

export default function Painel(props) {

    useEffect(() => {
        const { ppraId } = props.match.params;
        buscarTokenPpra()
        window.location.replace(`http://sistema.segure.com.br/ppra/${ppraId}/painel`)
    }, [])

    async function buscarTokenPpra() {
        await api.get(`/ppras/gerarTokenPpra/${props.match.params.ppraId}`)
            .then((resposta) => localStorage.setItem('ppra', resposta.data))
    }

    return (
        <div>
            Redirecionando...
        </div>
    )

}


